import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import Header from './components/Header'
import Hero from './components/Hero'
import PredictionsSection from './components/PredictionsSection'
import TeamAnalysis from './components/TeamAnalysis'
import Footer from './components/Footer'
import LoadingSpinner from './components/LoadingSpinner'

function App() {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <div className="min-h-screen bg-gradient-to-br from-fpl-gray via-fpl-light-gray to-fpl-gray">
      <AnimatePresence>
        {isLoading && <LoadingSpinner />}
      </AnimatePresence>
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative"
      >
        <Header />
        
        <main>
          <Hero />
          <PredictionsSection setIsLoading={setIsLoading} />
          <TeamAnalysis setIsLoading={setIsLoading} />
        </main>
        
        <Footer />
      </motion.div>
    </div>
  )
}

export default App
